<template>
  <div>
    <link-prevue :url="url">
      <template slot-scope="props">
        <div>
          <b-card
            :title="props.title"
            tag="article"
            style="max-width: 16rem;min-width:16rem;border-radius:15px"
            class="mb-2"
            no-body
          >
            <b-card-img :src="props.img" @error="imageUrlAlt" :alt="props.title" top style="border-top-left-radius: 15px;border-top-right-radius:15px;margin-left:0px;margin-right:0px;background:black" class="mb-2"></b-card-img>
            <h4 style="margin: 10px;" v-if="props.title">{{props.title}}</h4>
            <h4 style="margin: 10px;" v-else>{{url}}</h4>
            <b-card-text style="padding:10px;width:100%" class="mb-3" v-if="props.description">
              {{props.description}}
            </b-card-text>
            <b-button v-bind:href="props.url" style="color:white;background-color:#003366;border-bottom-left-radius: 15px;border-bottom-right-radius:15px">View More</b-button>
          </b-card>
        </div>
      </template>
    </link-prevue>
  </div>
</template>

<script>
import LinkPrevue from 'link-prevue'

export default {
  props: {
    url: {
      type: String,
      required: true
    }
  },
  data() {
    return {
    }
  },
  methods: {
    imageUrlAlt(event) {
      // event.target.src = "https://picsum.photos/300/200?grayscale"
      event.target.style.visibility = 'hidden'
      event.target.height = 0
    }
  },
  mounted() {
  },
  components: {
    LinkPrevue
  }
}
</script>